import { render, staticRenderFns } from "./CreateTestSale.vue?vue&type=template&id=878a1e0a&scoped=true"
import script from "./CreateTestSale.vue?vue&type=script&lang=js"
export * from "./CreateTestSale.vue?vue&type=script&lang=js"
import style0 from "./CreateTestSale.vue?vue&type=style&index=0&id=878a1e0a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "878a1e0a",
  null
  
)

export default component.exports